import { combineReducers } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import authReducer from './slices/authSlice';
import mapBoxSlice from "./slices/mapBoxSlice";
import subscriptionReducer from './slices/subscriptionSlice';
import adminAuthReducer from './slices/adminAuthSlice';
import transactionReducer from './slices/transactionSlice';
import adminPlansReducer from './slices/adminPlansSlice';
import userManagementReducer from './slices/userManagementSlice';

const persistConfig = {
  key: "root",
  storage,
};

const reducers = combineReducers({
  auth: authReducer,
  map: mapBoxSlice,
  subscription: subscriptionReducer,
  adminAuth: adminAuthReducer,
  transaction: transactionReducer,
  adminPlans: adminPlansReducer,
  userManagement: userManagementReducer
});

export default persistReducer(persistConfig, reducers);
